export default __webpack_public_path__ + "static/media/icComments.f451255a.svg";